// @copyright  2025 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    // Page titles
    'prepaid-expense.page.title': 'Prepaid Expenses',
    'prepaid_expenses.page_title': 'Prepaid Expenses',
    'prepaid-expense.page.create.title': 'Create Prepaid Expense',
    'prepaid_expenses.page.update.title': 'Update Prepaid Expense',
    'prepaid-expense.page.all': 'All Prepaid Expenses',

    // Buttons
    'prepaid-expense.button.create': 'Create Prepaid Expense',
    'prepaid-expense.button.cancel': 'Cancel',
    'prepaid-expense.button.save': 'Save',
    'prepaid_expenses.edit': 'Edit',

    // Labels and Fields
    'prepaid-expense.label.status': 'Status',
    'prepaid_expenses.fields.prepayment_number': 'Prepayment Number',
    'prepaid_expenses.fields.prepayment_status': 'Status',
    'prepaid_expenses.fields.prepayment_date': 'Prepayment Date',
    'prepaid_expenses.fields.service_start_date': 'Service Start Date',
    'prepaid_expenses.fields.service_end_date': 'Service End Date',
    'prepaid_expenses.fields.entity': 'Entity',
    'prepaid_expenses.fields.general_ledger_account': 'General Ledger Account',
    'prepaid_expenses.fields.prepaid_asset_account': 'Prepaid Asset Account',
    'prepaid_expenses.fields.currency': 'Currency',
    'prepaid_expenses.fields.total_amount': 'Total Amount',
    'prepaid_expenses.fields.consumed_amount': 'Consumed Amount',
    'prepaid_expenses.fields.remaining_amount': 'Remaining Amount',
    'prepaid_expenses.fields.consumption_frequency': 'Consumption Frequency',
    'prepaid_expenses.fields.description': 'Description',
    'prepaid_expenses.fields.reference_number': 'Reference Number',
    'prepaid_expenses.fields.memo': 'Memo',
    'prepaid_expenses.fields.is_recurring': 'Recurring',
    'prepaid-expense.label.prepayment_date': 'Prepayment Date',
    'prepaid-expense.label.service_start_date': 'Service Start Date',
    'prepaid-expense.label.service_end_date': 'Service End Date',
    'prepaid-expense.label.entity_name': 'Entity',
    'prepaid-expense.label.expense_account': 'Expense Account',
    'prepaid-expense.label.prepaid_asset_account': 'Prepaid Asset Account',
    'prepaid-expense.label.currency': 'Currency',
    'prepaid-expense.label.total_amount': 'Total Amount',
    'prepaid-expense.label.total_periods': 'Total Periods',
    'prepaid-expense.label.consumption_frequency': 'Consumption Frequency',
    'prepaid-expense.label.description': 'Description',
    'prepaid-expense.label.reference_number': 'Reference Number',
    'prepaid-expense.label.memo': 'Memo',
    'prepaid-expense.label.prepayment_number': 'Prepayment Number',

    // Placeholders
    'prepaid-expense.placeholder.select_status': 'Select status',
    'prepaid-expense.placeholder.search': 'Search prepaid expenses...',
    'prepaid_expenses.search_placeholder': 'Search prepaid expenses...',

    // Search
    'prepaid-expense.search.title': 'Search Prepaid Expenses',
    'prepaid-expense.search.keyword': 'Keyword',
    'prepaid-expense.search.placeholder': 'Search prepaid expenses...',

    // Filters
    'prepaid_expenses.filters.status': 'Status',
    'prepaid_expenses.filters.date_from': 'Date From',
    'prepaid_expenses.filters.date_to': 'Date To',

    // Messages
    'prepaid-expense.message.created_successfully': 'Prepaid expense created successfully',
    'prepaid_expenses.message.updated_successfully': 'Prepaid expense updated successfully',
    'prepaid_expenses.validation.form_errors': 'Please correct the errors below',
    'prepaid_expenses.messages.error_loading': 'Sorry, there was an error loading the prepaid expense.',

    // Errors
    'prepaid-expense.error.message.error_loading_page': 'Sorry, there was an error loading the prepaid expense page.',
    'prepaid-expense.link.retry': 'Click here to retry',

    // Status
    'prepaid_expenses.status.PENDING': 'Pending',
    'prepaid_expenses.status.ACTIVE': 'Active',
    'prepaid_expenses.status.PARTIAL': 'Partial',
    'prepaid_expenses.status.COMPLETE': 'Complete',
    'prepaid_expenses.status.CANCELLED': 'Cancelled',
    'prepaid-expense.status.active': 'Active',
    'prepaid-expense.status.partially_consumed': 'Partially Consumed',
    'prepaid-expense.status.fully_consumed': 'Fully Consumed',

    // Frequency
    'prepaid_expenses.frequency.monthly': 'Monthly',
    'prepaid_expenses.frequency.quarterly': 'Quarterly',
    'prepaid_expenses.frequency.annually': 'Annually',
    'prepaid_expenses.frequency.weekly': 'Weekly',
    'prepaid_expenses.frequency.bi-weekly': 'Bi-Weekly',
    'prepaid-expense.frequency.monthly': 'Monthly',
    'prepaid-expense.frequency.quarterly': 'Quarterly',
    'prepaid-expense.frequency.annually': 'Annually',
    'prepaid-expense.frequency.weekly': 'Weekly',
    'prepaid-expense.frequency.bi-weekly': 'Bi-Weekly',
};
